import { render, staticRenderFns } from "./SizeColor.vue?vue&type=template&id=488b43d7&scoped=true"
import script from "./SizeColor.vue?vue&type=script&lang=js"
export * from "./SizeColor.vue?vue&type=script&lang=js"
import style0 from "./SizeColor.vue?vue&type=style&index=0&id=488b43d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b43d7",
  null
  
)

export default component.exports